
import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { defaultSettings } from './SettingConstant';

interface IProps {
    customSetting?: any;
    children?: any;
    className?: any;
    defaultItemClass?: boolean;
    overrideSettings?: boolean;
    responsive?: any;
}

let slider: any;

const MultipleSlider = (props: IProps) =>  {
    const { customSetting, children, className, defaultItemClass, overrideSettings, responsive } = props;
    const style = ['wf_multiple_items', className].join(' ');
    const settings = (!!customSetting) ? (!!overrideSettings) ? {...defaultSettings, ...customSetting} : customSetting : defaultSettings; 

    return (
        <Carousel
        responsive={responsive}
            ref={sliderVar => (slider = sliderVar)}
            className={style}
            {...settings}
            itemClass={defaultItemClass ? '' : 'item_width'}
        >
            {...children}
        </Carousel>
    )
}

export default MultipleSlider;